module.exports = __webpack_public_path__ + "img/13.6abc7511.jpg";